import { LoadingButton } from '@mui/lab'
import { Button, DialogActions, DialogContent, DialogContentText, Stack } from '@mui/material'
import React from 'react'
import {
  useDisableRegularlyPublishedCampaignMutation,
  RegularlyPublishedCampaignListDocument,
} from '~/generated/graphql'
import { ErrorAlert } from '~/components/common/ErrorAlert'
import { snackActions } from '~/lib/snackbarHelper'
import { logger } from '~/lib/logger'

export const RegularlyPublishedOnContent = (props: {
  onClose: () => void
  campaignId: string
  executionDay: number | null | undefined
}) => {
  const [disableRegularlyPublishedCampaign, { loading, error }] = useDisableRegularlyPublishedCampaignMutation({
    refetchQueries: [{ query: RegularlyPublishedCampaignListDocument }],
  })

  const handleDisable = async () => {
    try {
      await disableRegularlyPublishedCampaign({
        variables: { input: { campaignId: props.campaignId } },
      })
      if (props.executionDay) {
        snackActions.success('定期公開設定を中止しました。')
      } else {
        snackActions.success('定期公開予約を取り消しました。')
      }
      props.onClose()
    } catch (error) {
      console.error(error)
      if (props.executionDay) {
        snackActions.error('定期公開設定の中止に失敗しました。')
        logger.error(new Error('Failed to cancel regularly scheduled publishing', { cause: error }))
      } else {
        snackActions.error('定期公開予約の取り消しに失敗しました。')
        logger.error(new Error('Failed to revoke scheduled publishing reservation', { cause: error }))
      }
    }
  }

  return (
    <>
      <DialogContent>
        <Stack sx={{ mb: 3 }}>{error && <ErrorAlert title="定期公開の設定に失敗しました。" error={error} />}</Stack>
        <DialogContentText>
          {props.executionDay
            ? `毎月 ${props.executionDay}
          日にキャンペーンが自動で公開されるように設定されています。定期公開を中止しますか？`
            : '定期公開の予約を取り消しますか？'}
          <br />
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={props.onClose}>閉じる</Button>
        <LoadingButton onClick={handleDisable} loading={loading} variant="contained">
          {props.executionDay ? '中止する' : '取り消す'}
        </LoadingButton>
      </DialogActions>
    </>
  )
}
